import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Table,
} from 'semantic-ui-react';
import Pagination from 'dyzio-shared-components/lib/components/pagination';
import InfluencerTableRow from '../influencer-table-row';
import InfluencerActions from '../influencer-actions';
import InfluencerTableHeaderRow from '../influencer-table-header-row';
import InfluencerTableLoadingRow from '../influencer-table-loading-row';
import TryAgainView from '../try-again-view';
import * as countryList from '../../utils/helpers/countries';

class InfluencersTable extends React.Component {
  constructor() {
    super();
    this.state = {
      createdDate: null,
    };
  }

  shouldComponentUpdate(nextProps) {
    const oldProps = this.props;
    const state = this.state;

    const selectedChanged = oldProps.selected.length !== nextProps.selected.length;
    const dataChanged = state.createdDate != null && (state.createdDate < nextProps.createdDate);
    const finishedLoading = oldProps.loading !== nextProps.loading;
    const columnsChanged = _.isEqual(oldProps.columnsSettings, nextProps.columnsSettings);

    if (finishedLoading || selectedChanged || dataChanged || columnsChanged) {
      this.setState({
        createdDate: nextProps.createdDate,
      });
      return true;
    }

    return false;
  }

  render() {
    const {
      withActions,
      selected,
      reportUrls,
      shortlists,
      loading,
      sort,
      errors,
      totalInfluencers,
      currentPage,
      totalPages,
      links,
      handleCheckAllInfluencers,
      handleDeleteInfluencer,
      handleSaveShortlist,
      patchShortlist,
      handleSorting,
      incrementPage,
      decrementPage,
      tryAgainCallback,
      handleDeleteQueue,
      handleCheckChange,
      influencerPageRedirect,
      columnsSettings,
      displayAuthorisedData,
    } = this.props;

    return (
      <Table fixed sortable={!withActions} selectable singleLine>
        <Table.Header>
          {withActions && !loading && <InfluencerActions
            reportUrls={reportUrls}
            count={selected.length}
            shortlists={shortlists}
            onCheckAll={handleCheckAllInfluencers}
            onDelete={handleDeleteInfluencer}
            onSaveShortlist={handleSaveShortlist}
            onShortlistPatch={patchShortlist}
            columnsSettings={columnsSettings}
          />}
          {!withActions && !loading && <InfluencerTableHeaderRow
            onCheckAll={handleCheckAllInfluencers}
            onSort={handleSorting}
            sorting={sort}
            columnsSettings={columnsSettings}
          />}
        </Table.Header>
        <Table.Body>

          { loading && <InfluencerTableLoadingRow colSpan={11} /> }

          { !loading && errors.search &&
          <Table.Row>
            <Table.Cell colSpan={16} height="500" textAlign="center">
              <TryAgainView
                onClick={tryAgainCallback}
              />
            </Table.Cell>
          </Table.Row>
          }

          { !loading && !errors.search && links && _.map(links,
            link => <InfluencerTableRow
              displayAuthorisedData={displayAuthorisedData}
              columnsSettings={columnsSettings}
              key={link.id}
              selected={selected}
              colSpan={12}
              link={link}
              countries={countryList.default}
              onDeleteQueue={handleDeleteQueue}
              handleRowClick={influencerPageRedirect}
              onCheckboxStateUpdated={handleCheckChange}
            />)
          }
        </Table.Body>
        {!loading && (totalInfluencers > 25) && <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan="10">
              <Pagination
                onPageIncrement={incrementPage}
                onPageDecrement={decrementPage}
                currentPage={currentPage}
                totalPages={totalPages}
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>}
      </Table>
    );
  }
}

InfluencersTable.propTypes = {
  withActions: PropTypes.bool.isRequired,
  selected: PropTypes.array.isRequired,
  shortlists: PropTypes.array.isRequired,
  links: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  sort: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  totalInfluencers: PropTypes.number.isRequired,
  handleCheckAllInfluencers: PropTypes.func.isRequired,
  handleDeleteInfluencer: PropTypes.func.isRequired,
  handleSaveShortlist: PropTypes.func.isRequired,
  patchShortlist: PropTypes.func.isRequired,
  handleSorting: PropTypes.func.isRequired,
  incrementPage: PropTypes.func.isRequired,
  decrementPage: PropTypes.func.isRequired,
  tryAgainCallback: PropTypes.func.isRequired,
  handleDeleteQueue: PropTypes.func.isRequired,
  handleCheckChange: PropTypes.func.isRequired,
  influencerPageRedirect: PropTypes.func.isRequired,
  reportUrls: PropTypes.object.isRequired,
  columnsSettings: PropTypes.object.isRequired,
};

export default InfluencersTable;



/** WEBPACK FOOTER **
 ** ./src/components/influencers-table/index.js
 **/